// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsListFeature":"vw_a bha_b","TwoDimsListFeature__item":"vw_b bha_ux","TwoDimsListFeature__item__text":"vw_c bha_un"};